import React, { Component } from 'react';
import { employees } from './data/employeesData';
import Employee from './components/Employee';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDepartment: "All",
      searchQuery: ""
    };
  }

  handleFilter = (dept) => {
    this.setState({ selectedDepartment: dept });
  }

  handleSearch = (e) => {
    this.setState({ searchQuery: e.target.value });
  }

  render() {
    const { selectedDepartment, searchQuery } = this.state;

    // Filter employees
    let filteredEmployees = selectedDepartment === "All"
      ? employees
      : employees.filter(emp => emp.department === selectedDepartment);

    // Search by name or designation
    filteredEmployees = filteredEmployees.filter(emp =>
      emp.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      emp.designation.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
      <>
        {/* Navbar */}
        <nav className="navbar navbar-expand-lg navbar-dark bg-primary shadow-sm">
          <div className="container-fluid">
            <a className="navbar-brand fw-bold" href="/">Employee Dashboard</a>
            <form className="d-flex ms-auto" role="search">
              <input
                className="form-control"
                type="search"
                placeholder="Search employees..."
                value={this.state.searchQuery}
                onChange={this.handleSearch}
              />
            </form>
          </div>
        </nav>

        <div className="container my-5">
          <h2 className="text-center mb-4 fw-bold">Employee Records</h2>

          {/* Filter Buttons */}
          <div className="card shadow-sm mb-4 border-0">
            <div className="card-body d-flex justify-content-center flex-wrap">
              {["All", "IT", "HR", "Finance", "Marketing"].map((dept, index) => (
                <button
                  key={index}
                  className={`btn btn-${selectedDepartment === dept ? "primary" : "outline-primary"} mx-2 mb-2`}
                  onClick={() => this.handleFilter(dept)}
                >
                  {dept}
                </button>
              ))}
            </div>
          </div>

          {/* Employee Cards */}
          <div className="row">
            {filteredEmployees.length > 0 ? (
              filteredEmployees.map(emp => <Employee key={emp.id} data={emp} />)
            ) : (
              <p className="text-danger text-center">No employees found.</p>
            )}
          </div>
        </div>

        {/* Footer */}
        <footer className="bg-gradient text-light text-center py-3 mt-5" style={{ background: "linear-gradient(90deg, #007bff, #6610f2)" }}>
          <p className="mb-0">© {new Date().getFullYear()} Employee Dashboard | Built with React & Bootstrap</p>
        </footer>
      </>
    );
  }
}

export default App;

